<template>
  <v-container class="component_main px-6">
    <v-row class="pr-3 pb-4">
      <v-col cols="4" class="py-0">
        <h1>Edição de Recursos de glosa</h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        height="30px"
        small
        color="primary"
        class="px-2 ml-3 mt-2 mb-1"
        depressed
        @click="validateEdit()"
        >Fechar</v-btn
      >
      <v-btn
        outlined
        height="30px"
        small
        color="primary"
        class="px-2 ml-3 mt-2 mb-1"
        depressed
        v-show="false"
        @click="validateEdit(true)"
        >Liberar edição</v-btn
      >
      <v-btn v-if="grupoEconomico == 167 && userData.UsuarioTradimus"
        outlined
        height="30px"
        small
        color="primary"
        class="px-2 ml-3 mt-2 mb-1"
        depressed
        @click="openPendencia()"
        >Pendências</v-btn>
      <v-btn
        outlined
        height="30px"
        small
        color="primary"
        class="px-2 ml-3 mt-2 mb-1"
        depressed
        @click="getHistorico(paramId, pagamentoId)"
        >Histórico de edições</v-btn
      >
    </v-row>
    <v-row class="ma-0 pa-3 mb-5" style="background-color: #d1dcea">
      <v-col cols="2" class="pa-0 ma-0">
        <div class="px-0 py-1">
          <small>Data do pagamento:</small><br />
          <h1 class="mt-n1">
            {{ dadosPagamento.data_pagamento | formatDate }}
          </h1>
        </div>
      </v-col>
      <v-col cols="2" class="pa-0 ma-0">
        <div class="px-0 pt-2">
          <b>{{ dadosPagamento.oper_nome }}</b
          ><br />
          {{ dadosPagamento.prest_nome }}
        </div>
      </v-col>
      <v-col cols="8" class="pa-0">
        <v-row class="ma-0">
          <v-col class="text-list text-right px-0 py-2"
            ><small>Vl. informado (R$):</small><br /><b>{{
              dadosPagamento.valor_informado | formatPrice
            }}</b></v-col
          >
          <v-col class="text-list text-right px-0 py-2"
            ><small>Vl. lib. de produção (R$):</small><br /><b
              style="color: green"
              >{{ dadosPagamento.valor_liberado | formatPrice }}</b
            ></v-col
          >
          <v-col class="text-list text-right px-0 py-2"
            ><small>Vl. glosado (R$):</small><br /><b
              ><span style="color: red">{{
                (dadosPagamento.valor_glosado + dadosPagamento.valor_glosa_mantida) | formatPrice
              }}</span></b
            ></v-col
          >
          <v-col class="text-list text-right px-0 py-2">
            <v-tooltip bottom v-if="dadosPagamento.doc_id_resultado">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-5 mt-2"
                  color="primary"
                  medium
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    getDocument({ doc_id: dadosPagamento.doc_id_resultado })
                  "
                  >fa-file-invoice
                </v-icon>
              </template>
              <span
                class="px-3 py-1 ma-0"
                style="
                  border: solid 1px #999;
                  border-radius: 5px;
                  background-color: #fff;
                "
                >Resultados</span
              >
            </v-tooltip>
            <v-tooltip bottom v-if="dadosPagamento.doc_id_dac">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-3 mt-2"
                  color="primary"
                  medium
                  v-bind="attrs"
                  v-on="on"
                  @click="getDocument({ doc_id: dadosPagamento.doc_id_dac })"
                  >fa-file-archive
                </v-icon>
              </template>
              <span
                class="px-3 py-1 ma-0"
                style="
                  border: solid 1px #999;
                  border-radius: 5px;
                  background-color: #fff;
                "
                >DAC - Demonstrativo de Análise de Contas</span
              >
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- <v-row class="ma-0">
      <v-col class="px-1 py-0" cols="6">
        <v-row class="ma-0 pr-8">
          <v-col class="text-list text-center px-0 pt-0 pb-2"
            ><small>Vl. analisado (R$):</small><br /><b>{{
              dadosPagamento.valor_analisado
                ? dadosPagamento.valor_analisado
                : 0 | formatPrice
            }}</b></v-col
          >
          <v-col class="text-list text-center px-0 pt-0 pb-2"
            ><small>Vl. recursado (R$):</small><br /><b style="color: green">{{
              dadosPagamento.valor_recursado
                ? dadosPagamento.valor_recursado
                : 0 | formatPrice
            }}</b></v-col
          >
          <v-col class="text-list text-center px-0 pt-0 pb-2"
            ><small>Vl. acatado (R$):</small><br /><b
              ><span style="color: red">{{
                dadosPagamento.valor_acatado
                  ? dadosPagamento.valor_acatado
                  : 0 | formatPrice
              }}</span></b
            ></v-col
          >
        </v-row>
      </v-col>
      <v-col class="px-4 pt-2 pb-5" cols="6">
        <v-progress-linear
          :value="dadosPagamento.porc_analisados"
          color="primary"
        ></v-progress-linear>
        <v-row class="pt-4 px-2">
          <v-col class="px-2 py-1" cols="6"
            >Analisado:
            <b
              >{{ dadosPagamento.qtd_guia_com_analise }}
              {{ dadosPagamento.qtd_guia_com_analise > 1 ? "guias" : "guia" }} /
              {{ dadosPagamento.qtd_item_com_analise }}
              {{
                dadosPagamento.qtd_item_com_analise > 1 ? "itens" : "item"
              }}</b
            >
            ({{ dadosPagamento.porc_analisados }}%)</v-col
          >
          <v-col class="text-right px-2 py-1" cols="6"
            >Aguardando análise:
            <b
              >{{
                dadosPagamento.qtd_guia_total -
                dadosPagamento.qtd_guia_com_analise
              }}
              {{
                dadosPagamento.qtd_guia_total -
                  dadosPagamento.qtd_guia_com_analise >
                1
                  ? "guias"
                  : "guia"
              }}
              /
              {{
                dadosPagamento.qtd_item_total -
                dadosPagamento.qtd_item_com_analise
              }}
              {{
                dadosPagamento.qtd_item_total -
                  dadosPagamento.qtd_item_com_analise >
                1
                  ? "itens"
                  : "item"
              }}</b
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row> -->
    <!-- <v-divider /> -->
    <v-row>
      <v-col cols="12">
        <v-tabs class="elevation-0" v-model="tab">
          <v-tab href="#tab-resumo" @click="trocaAba('tab-resumo')"
            >Motivos das glosas</v-tab
          >
          <v-tab
            href="#tab-edit-recursos-reg"
            :disabled="tabsDesativadas.regular"
            @click="trocaAba('tab-edit-recursos-reg')"
            >Glosa Regular</v-tab
          >
          <v-tab
            href="#tab-edit-recursos-man"
            :disabled="tabsDesativadas.mantida"
            @click="trocaAba('tab-edit-recursos-man')"
            >Glosa Mantida</v-tab
          >
          <v-tab
            href="#tab-edit-recursos-reap"
            :disabled="tabsDesativadas.reapresentacao"
            @click="trocaAba('tab-edit-recursos-reap')"
            v-if="parametros && parametros.RG_REAPRESENTACAO"
            >Reapresentação</v-tab
          >

      <v-tabs-items v-model="tab">
            <v-tab-item value="tab-resumo" class="pa-0">
              <v-row class="px-3 pt-4">
                <MotivosGlosaList
                  :list="motivosGlosaList"
                  :setTab="(aba, info) => setTab(aba, info)"
                  :getFile="() => getFile()"
                />
              </v-row>
            </v-tab-item>

            <v-tab-item value="tab-edit-recursos-reg" class="pa-0">
              <ResumoAnalise :info="analiseRegular"/>
              <v-divider />
              <GuiasFilter
                :filterList="(formData) => filterList(formData, 1, false)"
                :filterData="filterData"
                :motivosGlosaList="motivosGlosaList"
                :prestadoresList="identificadorPrestadoresList"
                :procedimentosList="procedimentosList"
                :estadoList="estadoList[tipo_consulta]"
                :dataToSave="dataToSave"
                :tipo_consulta="tipo_consulta"
                :tipo_pagamento="filterData.tipo_pagamento"
                :concluirRecurso="
                  (formData) => confirmConcluirRecurso(formData)
                "
                :dadosQuantidade="dadosQuantidade"
                :TabelasList="tabelasList"
                :parametros="parametros"
              />
                <!-- :dadosPagamento="dadosPagamento" -->
              <List
                :dadosPagamento="dadosPagamento"
                :anexarEmMassa="(bool)=>anexarEmMassa(bool)"
                :list="list"
                :pagination="pagination"
                :filterData="filterData"
                :motivosGlosaList="motivosGlosaList"
                :getList="(filtros, page) => filterList(filtros, page)"
                :parametros="parametros"
                :saveEdicoes="(isIndividual) => saveEdicoes(isIndividual)"
                :tipo_consulta="tipo_consulta"
                :updateDataToSave="updateDataToSave"
                :dataToSave="dataToSave"
                :dataMassToSave="dataMassToSave"
                :openUpload="(item) => openUpload(item)"
                :openGestao="()=>getArquivosAnexo({}, 1)"
                :openEdicaoIndividual="(item) => openEdicaoIndividual(item)"
                :valorGlosadoTotal="valor_glosado_total"
                :edicaoEmMassa="(bool) => edicaoEmMassa(bool)"
                :saveEdicaoEmMassa="saveEdicaoEmMassa"
                :estadoList="estadoList[tipo_consulta]"
                :desfazerEdicaoRecurso="
                  (data, selecionarTodos, seDesfazerEmMassa) => desfazerEdicaoRecurso(data, selecionarTodos, seDesfazerEmMassa)
                "
                :abreFormDados="(item) => abreFormDadosExtras(item)"
                :dadosExtras="dados_extras_config"
                :getGuiasAnalisadas="() => getGuiasAnalisadas()"
              />
            </v-tab-item>

            <v-tab-item value="tab-edit-recursos-man" class="pa-0">
              <ResumoAnalise :info="analiseMantida"/>
              <v-divider />
              <GuiasFilter
                :filterList="(formData) => filterList(formData, 1, false)"
                :filterData="filterData"
                :motivosGlosaList="motivosGlosaList"
                :prestadoresList="identificadorPrestadoresList"
                :procedimentosList="procedimentosList"
                :estadoList="estadoList[tipo_consulta]"
                :dataToSave="dataToSave"
                :tipo_consulta="tipo_consulta"
                :concluirRecurso="
                  (formData) => confirmConcluirRecurso(formData)
                "
                :dadosQuantidade="dadosQuantidade"
                :TabelasList="tabelasList"
                :parametros="parametros"
              />
              <List
                :anexarEmMassa="(bool)=>anexarEmMassa(bool)"
                :dadosPagamento="dadosPagamento"
                :list="list"
                :pagination="pagination"
                :parametros="parametros"
                :filterData="filterData"
                :motivosGlosaList="motivosGlosaList"
                :getList="(filtros, page) => filterList(filtros, page)"
                :saveEdicoes="(isIndividual) => saveEdicoes(isIndividual)"
                :tipo_consulta="tipo_consulta"
                :updateDataToSave="updateDataToSave"
                :dataToSave="dataToSave"
                :dataMassToSave="dataMassToSave"
                :openEdicaoIndividual="(item) => openEdicaoIndividual(item)"
                :openUpload="(item) => openUpload(item)"
                :openGestao="()=>getArquivosAnexo({}, 1)"
                :valorGlosadoTotal="valor_glosado_total"
                :edicaoEmMassa="(bool) => edicaoEmMassa(bool)"
                :saveEdicaoEmMassa="saveEdicaoEmMassa"
                :estadoList="estadoList[tipo_consulta]"
                :desfazerEdicaoRecurso="
                  (data, selecionarTodos, seDesfazerEmMassa) => desfazerEdicaoRecurso(data, selecionarTodos, seDesfazerEmMassa)
                "
                :abreFormDados="(item) => abreFormDadosExtras(item)"
                :dadosExtras="dados_extras_config"
                :getGuiasAnalisadas="() => getGuiasAnalisadas()"
              />
            </v-tab-item>
            <v-tab-item value="tab-edit-recursos-reap" class="pa-0">
              <ResumoAnalise :info="analiseReapresentacao"/>
              <v-divider />
              <GuiasFilter
                :filterList="(formData) => filterList(formData, 1, false)"
                :filterData="filterData"
                :motivosGlosaList="motivosGlosaList"
                :prestadoresList="identificadorPrestadoresList"
                :procedimentosList="procedimentosList"
                :estadoList="estadoList[tipo_consulta]"
                :dataToSave="dataToSave"
                :tipo_consulta="tipo_consulta"
                :concluirRecurso="
                  (formData) => confirmConcluirRecurso(formData)
                "
                :dadosQuantidade="dadosQuantidade"
                :TabelasList="tabelasList"
              />
              <List
                :anexarEmMassa="(bool)=>anexarEmMassa(bool)"
                :dadosPagamento="dadosPagamento"
                :list="list"
                :pagination="pagination"
                :parametros="parametros"
                :filterData="filterData"
                :motivosGlosaList="motivosGlosaList"
                :getList="(filtros, page) => filterList(filtros, page)"
                :saveEdicoes="(isIndividual) => saveEdicoes(isIndividual)"
                :tipo_consulta="tipo_consulta"
                :updateDataToSave="updateDataToSave"
                :dataToSave="dataToSave"
                :dataMassToSave="dataMassToSave"
                :openUpload="(item) => openUpload(item)"
                :openGestao="()=>getArquivosAnexo({}, 1)"
                :valorGlosadoTotal="valor_glosado_total"
                :edicaoEmMassa="(bool) => edicaoEmMassa(bool)"
                :saveEdicaoEmMassa="saveEdicaoEmMassa"
                :estadoList="estadoList[tipo_consulta]"
                :desfazerEdicaoRecurso="
                  (data, selecionarTodos, seDesfazerEmMassa) => desfazerEdicaoRecurso(data, selecionarTodos, seDesfazerEmMassa)
                "
                :abreFormDados="(item) => abreFormDadosExtras(item)"
                :dadosExtras="dados_extras_config"
                :getGuiasAnalisadas="() => getGuiasAnalisadas()"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>
    <EdicaoMassaDlg
      :close="() => (dialogForm = false)"
      :dialog="dialogForm"
      :formDataPre="formDataPre"
      :save="(data) => saveEdicoes(data)"
      :edicaoMassa="dataMassToSave"
      :tipo_consulta="tipo_consulta"
      :total="
        selecionar_todos
          ? pagination.total - dataMassToSave[tipo_consulta].length
          : dataMassToSave[tipo_consulta].length
      "
      :filterData="filterData"
      :isValoresIguais="isValoresIguais"
      :valValoresIguais="valor_glosado_total / pagination.total"
      :pagamento_id="pagamentoId"
      :dadosExtrasConfig="dados_extras_config"
      :grupoEconomico="grupoEconomico"
      :reapresentacao="filterData.reapresentacao"
      :parametros="parametros"
    />
    <EdicaoIndividualDlg
      :close="() => (dialogEdicaoIndividual = false)"
      :dialog="dialogEdicaoIndividual"
      :formDataPre="formDataPre"
      :save="(bool, dados ) => saveEdicoes(bool, dados)"
      :itemSelecionado="itemSelecionado"
      :tipo_consulta="tipo_consulta"
      :pagamento_id="pagamentoId"
      :dadosExtrasConfig="dados_extras_config"
      :grupoEconomico="grupoEconomico"
      :reapresentacao="filterData.reapresentacao"
      :parametros="parametros"
    />
    <AnexosUploadDlg
      :close="() => closeUploadDlg()"
      :dialog="showUploadDlg"
      :grupoEconomico="grupoEconomico"
      :dadosPagamento="dadosPagamento"
      :itemSelecionado="itemSelecionado"
      :tipoConsulta="filterData.tipo_consulta"
      :filterData="filterData"
      :emMassa="anexo_em_massa"
      :edicaoMassa="dataMassToSave"
      :selecionarTodos="selecionar_todos"
      :total="
        selecionar_todos
          ? Number(pagination.total) - dataMassToSave[tipo_consulta].length
          : dataMassToSave[tipo_consulta].length
      "
      :listaArquivos="listaArquivos"
      :getArquivosAnexo="(item) => getArquivosAnexo(item)"
      :parametros="parametros"
      :num_lote="itemSelecionado.numero_lote"
    />
    <AnexosGestaoDlg
    v-if="filterData.tipo_consulta=='guias'"
      :close="() => closeUploadDlg()"
      :dialog="showAnexosGestaoDlg"
      :grupoEconomico="grupoEconomico"
      :dadosPagamento="dadosPagamento"
      tipoConsulta="guias"
      :listaArquivos="listaArquivos"
      :getArquivosAnexo="(item, page) => getArquivosAnexo(item, page)"
      :parametros="parametros"
      :paginacao="anexos_paginacao"
    />
    <AnexosItensGestaoDlg
    v-else-if="filterData.tipo_consulta=='itens'"
      :close="() => closeUploadDlg()"
      :dialog="showAnexosGestaoDlg"
      :grupoEconomico="grupoEconomico"
      :dadosPagamento="dadosPagamento"
      tipoConsulta="itens"
      :listaArquivos="listaArquivos"
      :getArquivosAnexo="(item, page) => getArquivosAnexo(item, page)"
      :parametros="parametros"
      :paginacao="anexos_paginacao"
    />
    <HistoricoEdicoesDlgRec
      :dialog="showHistorico"
      :close="() => (showHistorico = false)"
      :historico="historicoEdicoes"
    />

    <DadosExtrasDlg
      :close="() => (showDadosExtraForm = false)"
      :dadosExtrasConfig="dados_extras_config"
      :dialog="showDadosExtraForm"
      :formDataPre="formDataPre"
      :grupoEconomico="grupoEconomico"
      :itemSelecionado="itemSelecionado"
      :reapresentacao="filterData.reapresentacao"
      :tipo="tipo_consulta"
    />
    <PendenciaDlg
      :dialog="showPendenciaDlg"
      :close="() => (showPendenciaDlg = false)"
      :grupoEconomico="grupoEconomico"
      :info="dadosPagamento"
      origem="edicao"
      :pendencia="{}"
      :updatePage="() => getRecursoGlosa(pagamentoId, paramId)"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AnexosGestaoDlg from "@/components/recebiveis/recursos_de_glosa/AnexosGestaoDlg";
import AnexosItensGestaoDlg from "@/components/recebiveis/recursos_de_glosa/AnexosGestaoDlg";
import AnexosUploadDlg from "@/components/recebiveis/recursos_de_glosa/AnexosUploadDlg";
import EdicaoMassaDlg from "@/components/recebiveis/recursos_de_glosa_edicao/EdicaoMassaDlg";
import EdicaoIndividualDlg from "@/components/recebiveis/recursos_de_glosa_edicao/EdicaoIndividualDlg";
import GuiasFilter from "@/components/recebiveis/recursos_de_glosa_edicao/Filter";
import List from "@/components/recebiveis/recursos_de_glosa_edicao/List";
import MotivosGlosaList from "@/components/recebiveis/recursos_de_glosa_edicao/MotivosGlosaList";
import PendenciaDlg from "@/components/recebiveis/recursos_de_glosa_edicao/PendenciaDlg";
import HistoricoEdicoesDlgRec from "@/components/recebiveis/recursos_de_glosa_edicao/HistoricoEdicoesDlgRec";
import DadosExtrasDlg from "@/components/recebiveis/recursos_de_glosa_edicao/DadosExtrasDlg";
import ResumoAnalise from "@/components/recebiveis/recursos_de_glosa_edicao/ResumoAnalise";
export default {
  components: {
    AnexosGestaoDlg,
    AnexosItensGestaoDlg,
    AnexosUploadDlg,
    DadosExtrasDlg,
    EdicaoIndividualDlg,
    EdicaoMassaDlg,
    GuiasFilter,
    HistoricoEdicoesDlgRec,
    List,
    MotivosGlosaList,
    PendenciaDlg,
    ResumoAnalise
  },
  data() {
    return {
      analiseRegular:{
        valor_acatado: 0,
        valor_glosado: 0, 
        valor_recursado: 0,
        porc_analisados:0,
        qtd_guia_com_analise:0,
        qtd_guia_total:0,
        qtd_item_com_analise:0,
        qtd_item_total:0
      },
      analiseMantida:{
        valor_acatado: 0,
        valor_glosado: 0, 
        valor_recursado: 0,
        porc_analisados:0,
        qtd_guia_com_analise:0,
        qtd_guia_total:0,
        qtd_item_com_analise:0,
        qtd_item_total:0
      },
      analiseReapresentacao:{
        valor_acatado: 0,
        valor_glosado: 0, 
        valor_recursado: 0,
        porc_analisados:0,
        qtd_guia_com_analise:0,
        qtd_guia_total:0,
        qtd_item_com_analise:0,
        qtd_item_total:0
      },
      anexos_paginacao: {
        limit: 20,
        offset: 1,
        total_pages: 0,
        total: 0,
      },
      acoesList: [
        { tipo: "lotes", acao: "getlotesrecursados" },
        { tipo: "guias", acao: "getguiasrecursoglosaedicao" },
        { tipo: "itens", acao: "getitensrecursoglosaedicao" },
      ],
      anexo_em_massa: false,
      listaArquivos: [],
      totalArquivos: 0,
      dadosPagamento: {
        prestador_id: null,
      },
      configInicial: null,
      dadosExtrasPorTipo: {},
      dialogForm: false,
      dialogEdicaoIndividual: false,
      dialog: false,
      edicaoMassa: null,
      filterData: {
        motivo_glosa: null,
        reapresentacao: false,
        cod_procedimento: null,
        identificacao_prestador: null,
        analisadas: false,
        tipo_consulta: "guias",
        MotivosDeGlosa: false,
        estado: null,
        tipo_pagamento: 0,
      }, // Atualizar filtro  no componente de filtro
      formDataPre: {
        Dados: {
          Recurso: {
            campo: [],
          },
          Reapresentacao: {
            campo: [],
          },
        },
      },
      historicoEdicoes: [],
      showHistorico: false,
      headers: [
        {
          text: "Protocolo recursado",
          value: "protocolo_recursado",
          sortable: false,
        },
        { text: "Nº do Lote", value: "numero_lote", sortable: false },
        {
          text: "N da Guia do Recurso",
          value: "numero_guia_recurso",
          sortable: false,
        },
        { text: "Vl. Recursado", value: "valor_recursado", sortable: false },
        {
          text: "Data atualização",
          value: "data_atualizacao",
          sortable: false,
        },
        { text: "Anexos", value: "anexo", align: "center", sortable: false },
      ],
      itemSelecionado: {},
      // mesmoFiltro: false,
      pagination: {
        // Atualizar paginação de acordo com o retorno da busca
        limit: 10,
        offset: 1,
        total_pages: 0,
        total: 0,
      },
      pagamentoId: null,
      param: null,
      parametros: null,
      status: {
        autorizacoes: { text: "Autorizações", color: "#32b88b" },
        beneficiarios: { text: "Beneficiarios", color: "#b2b842" },
        divergencia_de_valores: {
          text: "Divergencia de valores",
          color: "#fc9d0a",
        },
        processo_de_cobranca: {
          text: "Processo de cobrança",
          color: "#fc5f17",
        },
        servico_nao_contratado: {
          text: "Serviço não contratado",
          color: "#d0021b",
        },
        outros: { text: "Outros", color: "#4a4a4a" },
        demais: { text: "Demais origens", color: "#979797" },
        demais_motivos: {
          text: "Somatório dos demais motivos",
          color: "#979797",
        },
      },
      tab: "tab-resumo",
      tipo_consulta: "guias",
      list: [],
      selectedItems: [],
      motivosGlosaList: [],
      procedimentosList: [],
      tabelasList:[],
      identificadorPrestadoresList: [],
      dataToSave: {
        itens: [],
        guias: [],
      },
      dataMassToSave: {
        itens: [],
        guias: [],
      },
      identificacaoPrestadorGuias: [],
      codigoProcedimento: [],
      showUploadDlg: false,
      selecionar_todos: false,
      valor_glosado_total: 0,
      saveEdicaoEmMassa: { update: false },
      estadoList: {
        itens: [
          {
            id: 1,
            descricao: "Guia analisada",
            cor: "primary",
          },
          {
            id: 2,
            descricao: "Item analisado",
            cor: "#cfd403",
          },
          {
            id: 4,
            descricao: "Aguardando Análise",
            cor: "#979797",
          },
        ],
        guias: [
          {
            id: 1,
            descricao: "Guia analisada",
            cor: "primary",
          },
          {
            id: 2,
            descricao: "Todos os itens analisados",
            cor: "#cfd403",
          },
          {
            id: 3,
            descricao: "Alguns itens analisados",
            cor: "#FC9D0A",
          },
          {
            id: 4,
            descricao: "Aguardando Análise",
            cor: "#979797",
          },
        ],
      },
      dataSave: null,
      isValoresIguais: false,
      verifica: false,
      showDadosExtraForm: false,
      dados_extras_config: { Recurso: {}, Reapresentacao: {} },
      dadosQuantidade: {},
      tabsDesativadas: {
        regular: false,
        mantida: false,
        reapresentacao: false,
      },
      showAnexosGestaoDlg: false,
      showPendenciaDlg: false
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData.userData,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
    }),
  },
  beforeMount() {
    this.prestadores =
      this.$store.getters["permissions/getPrestadoresByGeco"]();
    this.pagamentoId = this.$route.params.id;
    this.paramId = this.$route.query.integral
      ? "pagamento_id"
      : "identificacao_prestador_pagamento_id";
    this.getRecursoGlosa(this.pagamentoId, this.paramId).then(() => {
      this.getDadosExtras();
      this.getGuiasAnalisadas(true);
    });
  },
  mounted() {
    this.$store.commit("showLoader");
    this.guias = []
    this.verificaJson(this.guias)
  },
  methods: {
    ...mapActions({
      getDocumentPost: "documents/getDocumentPost",
      getDocument: "documents/getDocument",
    }),
    closeUploadDlg(){
      this.filterList(this.filterData, this.pagination.offset); 
      this.showUploadDlg = false; 
      this.anexo_em_massa = false;
      this.showAnexosGestaoDlg = false;
    },
    verificaJson(guias) {
      var camposMaiores = [
        "hash",
        "descricao_procedimento_demonstrado",
        "descricao_motivo_glosa",
      ];
      var ind = 0;
      guias.forEach((obj) => {
        if (obj != null && obj != undefined) {
          var chaves = Object.keys(obj);
          var ind2 = 0;
          chaves.forEach((el) => {
            if (obj[el] != null && obj[el] != undefined) {
              if (typeof obj[el] == "object") {
                var chaves2 = Object.keys(obj[el]);
                var ind3 = 0
                chaves2.forEach((el2) => {
                  if (obj[el][el2] != null && obj[el][el2] != undefined) {
                    if (typeof obj[el][el2] == "object") {
                      var chaves3 = Object.keys(obj[el][el2]);
                      chaves3.forEach((el3) => {
                      if (obj[el][el2][el3] != null && obj[el][el2][el3] != undefined) {
                        if (typeof obj[el][el2][el3] == "object") {
                          var chaves3 = Object.keys(obj[el][el2][el3]);
                          console.log(ind, "-", ind2, el2, chaves3);
                        } else {
                          if (obj[el][el2][el3].length > 20 && !camposMaiores.includes(el3))
                            console.log(ind, "-", ind2, el2, obj[el][el2][el3]);
                        }
                        }
                      })
                    } else {
                      if (obj[el][el2].length > 20 && !camposMaiores.includes(el2))
                          console.log(ind, ind2, ind3, el2, obj[el][el2]);
                    }
                  }
                  console.log(ind, ind2, ind3)
                  ind3++
                });
              } else {
                if (obj[el].length > 20 && !camposMaiores.includes(el))
                  console.log(ind, el, obj[el]);
              }
              ind2++;
            }
          });
          ind++;
          
        }
      });
    },
    getParametrizacao(pagamento) {
      let { prestador_id, operadora_ans_id } = pagamento;
      let opts = {
        query: [
          {
            Modulo: "Portal",
            Acao: "getparametrizacoes",
            Payload: {
              grupo_economico: this.grupoEconomico,
              prestador_id,
              operadora_ans_id,
            },
          },
        ],
        noLoader: true,
      };
      this.$store.dispatch("request/doRequest", opts).then((resp) => {
        this.parametros = resp.parametros;
      });
    },
    trocaAba(proxima) {
      if (this.dataToSave[this.tipo_consulta].length > 0) {
        let paramModal = {
          type: "warning",
          title: "Existem edições não salvas",
          message: "Se você continuar as edições serão perdidas",
          callback: (proxima) => {
            (this.dataToSave[this.tipo_consulta] = []),
              this.atualizaAba(proxima);
          },
          btConfirm: { name: "Continuar", show: true },
          btCancel: { name: "Cancelar", show: true, callback: () => {} },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        this.atualizaAba(proxima);
      }
    },
    atualizaAba(proxima) {
      if (proxima == this.tab) {
        return;
      } else {
        this.tab = proxima;
        this.filterData.motivo_glosa = null
        this.filterData.identificacao_prestador = null
        this.filterData.valor_glosado_set = null
        this.filterData.valor_glosado = null
        this.filterData.valor_informado_set = null
        this.filterData.valor_informado = null
        this.filterData.data_autorizacao = null
        this.filterData.data_execucao = null
        this.filterData.numero_guia = null
        this.filterData.codigo_procedimento = null
        this.filterData.estado = null
        this.filterData.analisadas = false
        this.filterData.nota_fiscal = null
        this.filterData.num_lote = null
        this.filterData.protocolo = null
        this.filterData.tipoPesquisa = null
        this.filterData.tipo_consulta = "guias";
        switch (proxima) {
          case "tab-edit-recursos-reg":
            this.filterData.tipo_pagamento = 0;
            this.filterData.reapresentacao = false;
            this.filterList(this.filterData, 1);
            break;
          case "tab-edit-recursos-man":
            this.filterData.tipo_pagamento = 10;
            this.filterData.reapresentacao = false;
            this.filterList(this.filterData, 1);
            break;
          case "tab-edit-recursos-reap":
            this.filterData.tipo_pagamento = 0;
            this.filterData.reapresentacao = true;
            this.filterList(this.filterData, 1);
            break;
        }
      }
    },
    openPendencia() {
      this.showPendenciaDlg = true;
    },
    openUpload(item) {
      this.tipo_consulta = this.filterData.tipo_consulta;
      this.itemSelecionado = item;
      this.getArquivosAnexo(item);
    },
    openEdicaoIndividual(item) {
      this.constroiForm().then(() => {
        this.tipo_consulta = this.filterData.tipo_consulta;
        this.itemSelecionado = item;
        this.dialogEdicaoIndividual = true;
      });
    },
    abreFormDadosExtras(item) {
      this.itemSelecionado = item;
      this.constroiForm(item).then(() => (this.showDadosExtraForm = true));
    },
    async constroiForm(item) {
      this.dadosExtrasPorTipo = {};

      if (this.tipo_consulta == "guias") {
        let recurso = await JSON.parse( this.configInicial )
        if(recurso){
          this.dadosExtrasPorTipo.Recurso = await recurso.Recurso.campo.filter((ele) => {
            return ele["Guia"] == "1";
          });
        } else {
          this.dadosExtrasPorTipo.Recurso = []
        }
      } else {
        let recurso = await JSON.parse( this.configInicial )
        if(recurso){
        this.dadosExtrasPorTipo.Recurso = await recurso.Recurso.campo;
        } else {
          this.dadosExtrasPorTipo.Recurso = []
        }
      }

      if (
        !item ||
        this.itemSelecionado.dados_extras == null ||
        this.itemSelecionado.dados_extras == {} ||
        this.itemSelecionado.dados_extras == "{}"
      ) {
        let item_dados_extras = JSON.stringify(this.dadosExtrasPorTipo.Recurso);
        this.formDataPre.Dados = { Recurso: { campo: [] } };

        await JSON.parse(item_dados_extras).forEach((ele) => {
          if (ele["ValorDefault"] != undefined) {
            this.formDataPre.Dados.Recurso.campo.push({
              Nome: ele.Nome.toUpperCase(),
              Valor: ele.ValorDefault,
            });
          }

          if (ele["ValorDefault"] == undefined) {
            this.formDataPre.Dados.Recurso.campo.push({
              Nome: ele.Nome.toUpperCase(),
              Valor: "",
            });
          }
        });
      } else {
        this.formDataPre = await JSON.parse(
          this.itemSelecionado.dados_extras.replaceAll("@", "")
        );
      }
      if (this.filterData.reapresentacao) {
        this.dadosExtrasPorTipo.Reapresentacao = await JSON.parse(
          this.configInicial
        ).Reapresentacao.campo;

        if (
          !item ||
          this.itemSelecionado.dados_extras == null ||
          this.itemSelecionado.dados_extras == {} ||
          this.itemSelecionado.dados_extras == "{}"
        ) {
          this.formDataPre.Dados.Reapresentacao = { campo: [] };

          await this.dadosExtrasPorTipo.Reapresentacao.forEach((ele) => {
            if (ele["ValorDefault"] != undefined) {
              this.formDataPre.Dados.Reapresentacao.campo.push({
                Nome: ele.Nome.toUpperCase(),
                Valor: ele.ValorDefault,
              });
            }
            if (ele["ValorDefault"] == undefined) {
              this.formDataPre.Dados.Reapresentacao.campo.push({
                Nome: ele.Nome.toUpperCase(),
                Valor: "",
              });
            }
          });
        } else {
          this.formDataPre = await JSON.parse(
            this.itemSelecionado.dados_extras.replaceAll("@", "")
          );
        }
      }
    },
    getDadosExtras() {
      let { prestador_id, operadora_ans_id } = this.dadosPagamento;
      let payload = {
        grupo_economico: this.grupoEconomico,
        prestador_id,
        operadora_ans_id,
      };

      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "getdadosextrasedicao",
            payload: payload,
          },
        ],
        returnError: true,
        noLoader: true
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || (response.erros && response.erros.length)) {
            this.$store.commit("hideLoader");
            return;
          }
          let dados_prestador = response.dados_extras_config_prestador.length
            ? JSON.parse(
                response.dados_extras_config_prestador.replaceAll("@", "")
              ).DadosConfig
            : {};
          let dados_operadora = response.dados_extras_config_operador.length
            ? JSON.parse(
                response.dados_extras_config_operador.replaceAll("@", "")
              ).DadosConfig
            : {};
          this.dados_extras_config = Object.assign(
            dados_prestador,
            dados_operadora
          );
          this.configInicial = JSON.stringify(this.dados_extras_config);
        });
    },
    getArquivosAnexo(item, page) {
      let gestaoArquivos = false
      let payload = { 
        grupo_economico: this.grupoEconomico,
        offset: 1,
        limit: 100
        };
      if(page !=null && page != undefined) {
        gestaoArquivos = true;
        payload = { 
          grupo_economico: this.grupoEconomico,
          pagamento_id: this.dadosPagamento.id,
          prestador_id: this.dadosPagamento.prestador_id,
          obj_type: this.tipo_consulta,
          offset: page,
          limit: 20,
          tipo_pagamento: this.filterData.tipo_pagamento 
        };
      } else {
        payload.prestador_id = this.dadosPagamento.prestador_id
        if (this.tipo_consulta == "guias") {
          payload.recurso_guia_id = item.id;
        } else if (this.tipo_consulta == "itens") {
          payload.recurso_item_id = item.id;
        }
      }
      let obj = {
        query: [
          { Modulo: "Recebiveis", Acao: "getanexorecurso", Payload: payload },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let listaCorrigida = [];
        if(response.dados.length > 0) {
          response.dados.forEach((dado, indice) => {
            listaCorrigida[indice] = {
              ...dado,
              dt_upload: dado.data_upload,
              nome: dado.arq_nome
            };
            this.listaArquivos = listaCorrigida;
          });
        }
        let {total, total_pages, current_page }= response
        this.anexos_paginacao = { total, total_pages, offset: current_page }
        if (listaCorrigida.length == 0) {
          this.listaArquivos = [];
        }
        this.totalArquivos = this.listaArquivos.length;
        if (this.listaArquivos.length >= 5 && !gestaoArquivos) {
          let paramModal = {
            type: "warning",
            title: "MAXIMO DE ARQUIVOS",
            message: "Quatidade maxima atingida",
            callback: () => {
              this.showUploadDlg = true;
            },
            btConfirm: { name: "OK", show: true },
            btCancel: { name: "Cancelar", show: false },
          };
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        } else {
          if(gestaoArquivos)
            this.showAnexosGestaoDlg = true;
          else
            this.showUploadDlg = true;
        }
      });
    },
    updateDataToSave(item, tipo) {
      let index = this.dataToSave[tipo].findIndex((el) => el.id == item.id);
      if (index > -1) {
        this.dataToSave[tipo][index] = { ...item };
      } else {
        this.dataToSave[tipo].push({ ...item });
        index = this.dataToSave[tipo].length - 1;
      }
      this.dataToSave[tipo][index].valor_acatado = Number(
        this.dataToSave[tipo][index].valor_acatado
      );
    },
    async getRecursoGlosa(id, param) {
      this.$store.commit("showLoader");
      let payload = { grupo_economico: this.grupoEconomico };
      payload[param] = id;
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "getrecursoglosaedicao",
            payload: payload,
          },
        ],
        returnError: true,
        noLoader: true
      }; //returnError: true
      await this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            let men = "";
            response.erros.forEach((ele) => {
              men += ele.descricao;
            });
            let paramModal = {
              type: "error",
              title: "Ocorreu erro",
              message: men,
              callback: () => {
                this.$router.push("/recebiveis/recursosdeglosa");
              },
              btConfirm: { name: "Ok", show: true },
            };
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
            return;
          }
          this.dadosPagamento = response;
          this.procedimentosList = response.codigo_procedimento;
          this.tabelasList = response.dm_tabela;

          // let procedimentos = [
          //   ...new Set(
          //     this.procedimentosList.map((ele) => ele.codigo_procedimento)
          //   ),
          // ];

          // let procedimentosSort = [];
          // procedimentos.forEach((ele) => procedimentosSort.push(Number(ele)));

          // procedimentosSort.sort();
          // let listProce = [];

          // procedimentosSort.forEach((ele) => {
          //   listProce.push({ codigo_procedimento: ele,  });
          // });
          this.getParametrizacao(this.dadosPagamento);
          //this.procedimentosList = listProce;
          this.identificadorPrestadoresList = response.identificador_prestador;
          return obj;
        })
        .then(() => {
          payload[param] = id;

          let opts = {
            query: [
              {
                modulo: "Recebiveis",
                acao: "getmotivosglosa",
                payload: payload,
              },
            ]
          };
          this.$store
            .dispatch("request/doRequest", opts, { root: true })
            .then((response) => {
              if (!response || response.isAxiosError || (response.erros && response.erros.length)) {
                this.$store.commit("hideLoader");
                return;
              }
              this.motivosGlosaList = response.dados;
              
            });
        });
    },
    openEdicaoEmMassa() {
      this.constroiForm().then(() => {
        this.dialogForm = true;
      });
    },
    getHistorico(param, id) {
      if (param == "identificacao_prestador_pagamento_id") {
        param = "pagamento_prestador_identificacao_id";
      }

      let payload = { grupo_economico: this.grupoEconomico };
      payload[param] = id;
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "gethistoricorecursos",
            payload: payload,
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((resp) => {
        if (resp.sucesso) {
          this.historicoEdicoes = resp.dados;
          this.showHistorico = true;
        }
      });
    },
    filterList(formData, page, tipo) {
      formData == null ? (formData = this.filterData) : null;
      // this.mesmoFiltro = mesmoFiltro
      let guiasAnalisadas =
        this.dataToSave.guias.filter((el) => el.status).length > 0;
      let itensAnalisados =
        this.dataToSave.itens.filter((el) => el.status).length > 0;
      if (!formData.analisadas && (guiasAnalisadas || itensAnalisados)) {
        setTimeout(() => {
          formData.analisadas = true;
          this.filterData = formData;
        }, 100);
        let paramModal = {
          type: "warning",
          title: "Aviso!",
          message: `Existem edições de ${guiasAnalisadas ? "guias" : ""} ${
            guiasAnalisadas && itensAnalisados ? "e" : ""
          } ${
            itensAnalisados ? "itens" : ""
          } já analisadas que não foram salvas, <br/> deseja prosseguir sem salvá-las?`,
          callback: () => {
            this.dataToSave.guias = this.dataToSave.guias.filter(
              (el) => !el.status
            );
            this.dataToSave.itens = this.dataToSave.itens.filter(
              (el) => !el.status
            );
            formData.analisadas = false;
            this.filterData = formData;
            this.filterList(this.filterData, this.pagination.offset);
          },
          btConfirm: { name: "sim", show: true, color: "warning" },
          btCancel: { name: "não", show: true, color: "warning" },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        this.pagination.offset = page ? page : 1;
        this.filterData = formData ? formData : this.filterData;
        this.tipo_consulta = tipo
          ? tipo
          : formData && formData.tipo_consulta
          ? formData.tipo_consulta
          : "guias";
        let acaoIndex = this.acoesList.findIndex(
          (el) => el.tipo == this.tipo_consulta
        );
        let acao = this.acoesList[acaoIndex].acao;
        let payload = Object.assign({
          grupo_economico: this.grupoEconomico,
          ...this.filterData,
          ...this.pagination,
        });
        payload[this.paramId] = this.pagamentoId;

        let obj = { query: [{ modulo: "Recebiveis", acao, payload }] };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }

            if (this.filterData.MotivosDeGlosa && response.dados.length == 0) {
              if (
                this.filterData.MotivosDeGlosa &&
                this.filterData.tipo_consulta == "itens"
              ) {
                this.filterData.MotivosDeGlosa = false;
                this.$nextTick(() => (this.filterData.tipo_consulta = "guias"));
              } else {
                this.filterData.tipo_consulta = "itens";
                this.$nextTick(() => this.filterList(this.filterData, 1));
              }
            }
            this.pagination.current_page = response.current_page;
            this.pagination.offset = response.current_page;
            this.pagination.total_pages = response.total_pages;
            this.pagination.total = response.total;
            this.valor_glosado_total = response.valor_glosado_total;
            this.isValoresIguais = response.is_valor_igual
            ? response.is_valor_igual
            : false;
            
            this.list = response.dados;

            /*
            this.list.forEach(e => {
              let dados = JSON.parse(e.dados_extras)
              e.area_geradora = dados.area_geradora
              e.direcionamento = dados.direcionamento
            });
            */
          });
      }

      this.getGuiasAnalisadas(true);
    },
    desfazerEdicaoRecurso(data, selecionar_todos, seDesfazerEmMassa ) {
      let obj_type = this.tipo_consulta;
      let pagamento_id = this.pagamentoId;
      this.selecionar_todos = selecionar_todos;
      this.filterData.selecionar_todos = selecionar_todos;
      let payload = {
          grupo_economico: this.grupoEconomico,
          pagamento_id,
          obj_type,
          ...this.filterData,
          seDesfazerEmMassa
        };

      if(seDesfazerEmMassa){
        payload.id = data.map(el => el.id)
      } else {
       payload.id = [data.id]
      }
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "desfazerEdicaoRecurso",
            payload: payload,
          },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || (response.erros && response.erros.length)) {
            this.$store.commit("hideLoader");
            return;
          }
          this.filterList(this.filterData, 1);
          this.getRecursoGlosa(this.pagamentoId, this.paramId);

          let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: response.mensagem,
            callback: () => {},
            btConfirm: { name: "Ok", show: true },
            btCancel: { name: "Cancelar", show: false },
          };

          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        });
    },
    desalocaRecurso(id, param) {
      let payload = { grupo_economico: this.grupoEconomico };
      payload[param] = id;
      let paramModal = {
        type: "info",
        title: "Deseja liberar as edições de guias?",
        message:
          "As edições serão mantidas e outro usuário poderá editar este lote. <br/> Caso queira gerar novo xml  do lote corrigido para transmissão clique em Concluir Edição",
        callback: () => {
          let obj = {
            query: [
              { modulo: "Recebiveis", acao: "desalocarecurso", payload },
            ],
          };
          this.$store.dispatch("request/doRequest", obj).then((resp) => {
            if (resp.sucesso) this.$router.push("/recebiveis/recursosdeglosa");
            // this.getLotesAlocados({grupo_economico: this.grupoEconomico})
          });
        },
        btConfirm: { name: "Ok", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    saveEdicoes(data, dados) {
      let gavacaoItemUnico = !!dados;
      // tipo individual - true ou em massa - false.
      let paramModal = {
        type: "success",
        title: "Sucesso!",
        message: "",
        callback: () => {
          data == true && gavacaoItemUnico
            ? null : data == true? (this.dataToSave[this.tipo_consulta] = [])
            : (this.dataMassToSave[this.tipo_consulta] = []);
          this.filterList(this.filterData, 1);
          this.getRecursoGlosa(this.pagamentoId, this.paramId);
        },
        btConfirm: { name: "Ok", show: true },
        btCancel: { name: "Cancelar", show: false },
      };

      let obj_type = this.tipo_consulta; //== "itens"? "item": "guia";
      if (data==true) {
        let objetos = gavacaoItemUnico? dados : this.dataToSave[this.tipo_consulta];

        if (this.tipo_consulta == "itens") {
          objetos.reduce((arr, item) => {
            if (typeof item.valor_recursado == "string") {
              item.valor_recursado =
                item.valor_recursado != null
                  ? Number(
                      item.valor_recursado
                        .replace(/[^\d]+/g, "")
                        .replace(/\B(?=(\d{2})(?!\d))/g, ".")
                    )
                  : 0;
            }

            if (typeof item.valor_acatado == "string") {
              item.valor_acatado =
                item.valor_acatado != null
                  ? Number(
                      item.valor_acatado
                        .replace(/[^\d]+/g, "")
                        .replace(/\B(?=(\d{2})(?!\d))/g, ".")
                    )
                  : 0;
            }

            // E o valor acatado????
            if (item) {
              arr.push(item);
            }
            return arr;
          }, []);
        }
        let payload = {};

        if (this.verifica) {
          payload = {
            grupo_economico: this.grupoEconomico,
            pagamento_id: objetos[0].pagamento_id,
            reapresentacao: this.filterData.reapresentacao,
            obj_type,
            objetos,
            sobrescrever: true,
          };
        } else {
          payload = {
            grupo_economico: this.grupoEconomico,
            pagamento_id: objetos[0].pagamento_id,
            reapresentacao: this.filterData.reapresentacao,
            obj_type,
            objetos,
            sobrescrever: false,
          };
        }

        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "saveRecursoGlosa",
              payload: payload,
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }

            if (response.sobrescrever) {
              paramModal.title = "Aviso!";
              paramModal.type = "warning";
              paramModal.btConfirm = {
                name: "sim",
                show: true,
                color: "warning",
              };
              paramModal.btCancel = {
                name: "não",
                show: true,
                color: "warning",
              };

              paramModal.callback = () => {
                this.verifica = true;
                this.saveEdicoes(true, dados);
              };
              paramModal.btCancel.callback = () => {
                this.dialogForm = false;
                this.dialogEdicaoIndividual = false;
              };
            } else {
              this.dialogForm = false;
              this.dialogEdicaoIndividual = false;
              this.verifica = false;
                
              if(gavacaoItemUnico)
                this.dataToSave[this.tipo_consulta] = this.dataToSave[this.tipo_consulta].filter(a=> a.id != dados[0].id)
              else 
               this.dataToSave[this.tipo_consulta] = [];
            }

            paramModal.message = response.mensagem;
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });
      } else {
        data.selecionar_todos = this.selecionar_todos;
        data[this.paramId] = this.pagamentoId;
        // data.analisadas = this.filterData.analisadas ?this.filterData.analisadas :false
        this.dataSave = data;
        let payload = {
          grupo_economico: this.grupoEconomico,
          reapresentacao: this.filterData.reapresentacao,
          ...data,
          obj_type,
          ...this.filterData,
        };

        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "edicaomassarecursoglosa",
              payload: payload,
            },
          ],
        };

        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            this.saveEdicaoEmMassa.update = true;
            this.dataSave.sobrescrever = false;
            if (response.sobrescrever) {
              paramModal.title = "Aviso!";
              paramModal.type = "warning";
              paramModal.btConfirm = {
                name: "sim",
                show: true,
                color: "warning",
              };
              paramModal.btCancel = {
                name: "não",
                show: true,
                color: "warning",
              };
              paramModal.callback = () => {
                this.dataSave.sobrescrever = true;
                this.saveEdicoes(this.dataSave);
              };
              paramModal.btCancel.callback = () => {
                this.dialogForm = false;
              };
            } else {
              this.dialogForm = false;
            }
            paramModal.message = response.mensagem;
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });
      }
    },
    setTab(aba, info) {
      //Quando tiver mais de uma aba, usar um switch case
      if(aba == 'tab-edit-recursos-reg' && this.tabsDesativadas.regular){
        if(!this.tabsDesativadas.mantida)
          aba = 'tab-edit-recursos-man'
        else if (!this.tabsDesativadas.reapresentacao)
          aba = 'tab-edit-recursos-reap'
        else 
          aba = 'tab-resumo'
      }

      if(aba == 'tab-edit-recursos-man' && this.tabsDesativadas.mantida){
        if(!this.tabsDesativadas.regular)
          aba = 'tab-edit-recursos-reg'
        else if (!this.tabsDesativadas.reapresentacao)
          aba = 'tab-edit-recursos-reap'
        else 
          aba = 'tab-resumo'
      }

      if(aba == 'tab-edit-recursos-reap' && this.tabsDesativadas.reapresentacao){
        if(!this.tabsDesativadas.regular)
          aba = 'tab-edit-recursos-reg'
        else if (!this.tabsDesativadas.mantida)
          aba = 'tab-edit-recursos-man'
        else 
          aba = 'tab-resumo'
      }
      this.tab = aba;
      this.filterData.tipo_consulta = "guias";
      this.filterData.motivo_glosa = info;
      this.filterData.MotivosDeGlosa = true;
      switch (aba) {
       case "tab-edit-recursos-reg":
            this.filterData.tipo_pagamento = 0;
            this.filterData.reapresentacao = false;
            //this.filterList(this.filterData, 1);
            break;
          case "tab-edit-recursos-man":
            this.filterData.tipo_pagamento = 10;
            this.filterData.reapresentacao = false;
            //this.filterList(this.filterData, 1);
            break;
          case "tab-edit-recursos-reap":
            this.filterData.tipo_pagamento = 0;
            this.filterData.reapresentacao = true;
            //this.filterList(this.filterData, 1);
            break;
      }
      this.$nextTick(() => this.filterList(this.filterData, 1));
    },
    edicaoEmMassa(bool) {
      this.selecionar_todos = bool;
      if (this.dataToSave[this.tipo_consulta].length) {
        let paramModal = {
          type: "warning",
          title: "Existem edições não salvas!",
          message:
            "Salve antes de continuar, ou você perderá as informações editadas.",
          callback: () => {
            this.dataToSave[this.tipo_consulta] = [];
            this.openEdicaoEmMassa();
          },
          btConfirm: {
            name: "Continuar sem salvar",
            show: true,
            color: "warning",
          },
          btCancel: { name: "Voltar", show: true, color: "warning" },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        this.openEdicaoEmMassa();
      }
    },
    anexarEmMassa(bool) {
      this.selecionar_todos = bool;
      this.$nextTick().then(()=>{
        this.anexo_em_massa = true;
        this.showUploadDlg = true;
      })
    },
    validateEdit(liberar) {
      /*
      if((this.userData.UserName != this.dadosPagamento.username_editing) && liberar){
        let paramModalDes = {
          type: "warning",
          title: "Aviso!",
          message:
            "Apenas o usuário que está editando , <br/> pode liberar o recurso",
          callback: () => {},
          btConfirm: { name: "OK", show: true, color: "warning" },
          btCancel: { name: "não", show: false, color: "warning" },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModalDes);
        return
      }
      */
      let paramModal = {
        type: "warning",
        title: "Aviso!",
        message:
          "Existem edições de recursos que não foram salvas, <br/> deseja prosseguir sem salvá-las?",
        callback: () => {},
        btConfirm: { name: "sim", show: true, color: "warning" },
        btCancel: { name: "não", show: true, color: "warning" },
      };
      if (this.dataToSave.guias.length || this.dataToSave.itens.length) {
        if (liberar) {
          paramModal.callback = () => {
            setTimeout(() => {
              this.desalocaRecurso(this.pagamentoId, this.paramId);
            }, 500);
          };
        } else {
          paramModal.callback = () => {
            this.$router.push("/recebiveis/recursosdeglosa");
          };
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        if (liberar) {
          this.desalocaRecurso(this.pagamentoId, this.paramId);
        } else {
          this.$router.push("/recebiveis/recursosdeglosa");
        }
      }
    },
    confirmConcluirRecurso(tipo_pagamento) {
      let pagto_id = this.pagamentoId;
      let paramModal = {
        type: "info",
        title: "Concluir o recurso de glosa",
        message: "Deseja concluir o recurso de glosa?",
        callback: () => this.concluirRecurso(pagto_id, tipo_pagamento),
        btConfirm: { name: "Concluir", show: true, color: "info" },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    concluirRecurso(id, tipo_pagamento) {
      let payload = {
        grupo_economico: this.grupoEconomico,
        prestador_id: this.dadosPagamento.prestador_id,
        tipo_pagamento,
        reapresentacao: this.filterData.reapresentacao,
      };
      payload[this.paramId] = id;
      let obj = {
        query: [
          { modulo: "Recebiveis", acao: "concluiredicao", payload: payload },
        ],
      };

      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: response.mensagem,
            callback: () => this.$router.push("/recebiveis/recursosdeglosa"),
            btConfirm: { name: "Concluir", show: true },
            btCancel: { name: "Cancelar", show: false },
          };
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        });
    },
    getFile() {
      let acao = "getcsvmotivosglosa";
      let Payload = { grupo_economico: 1 };
      Payload[this.paramId] = this.pagamentoId;
      this.getDocumentPost({ Payload, acao });
    },
    getGuiasAnalisadas(noLoader) {
      let payload = { grupo_economico: this.grupoEconomico };
      payload[this.paramId] = this.pagamentoId;
      payload.tipo_pagamento = this.filterData.tipo_pagamento;

      let obj = {
        query: [{ modulo: "Recebiveis", acao: "getguiasanalisadas", payload }],
        noLoader
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.dadosQuantidade = response;
          if (
            response.qdt_total_guia_mantida ==
            response.qdt_guia_concluida_mantida
          ) {
            this.tabsDesativadas["mantida"] = true;
          } else {
            this.tabsDesativadas["mantida"] = false;
          }

          if (
            response.qdt_total_guia_regular ==
            response.qdt_guia_concluida_regular
          ) {
            this.tabsDesativadas["regular"] = true;
          } else {
            this.tabsDesativadas["regular"] = false;
          }
          if (
            response.qdt_total_reapresentada ==
            response.qdt_guia_concluida_reapresentada
          ) {
            this.tabsDesativadas["reapresentacao"] = true;
          } else {
            this.tabsDesativadas["reapresentacao"] = false;
          }
          this.analiseRegular = {
            valor_acatado: response.regularValorAcatado,
            valor_glosado: response.regularValorGlosado, 
            valor_recursado: response.regularValorRecursado,
            valor_analisado: response.regularValorRecursado + response.regularValorAcatado,
            qtd_guia_com_analise: response.qdt_guia_analisada_regular,
            qtd_guia_concluida: response.qdt_guia_concluida_regular,
            qtd_guia_total: response.qdt_total_guia_regular,
            qtd_item_com_analise: response.qdt_item_analisado_regular,
            qtd_item_concluido: response.qdt_item_concluido_regular,
            qtd_item_total: response.qdt_total_item_regular,
            porc_analisados: Number(((response.qdt_item_analisado_regular+response.qdt_item_concluido_regular)/response.qdt_total_item_regular)*100).toFixed(2)
          }
          this.analiseMantida = {
            valor_acatado: response.mantidaValorAcatado,
            valor_glosado: response.mantidaValorGlosado, 
            valor_recursado: response.mantidaValorRecursado,
            valor_analisado: response.mantidaValorRecursado + response.mantidaValorAcatado,
            qtd_guia_com_analise: response.qdt_guia_analisada_mantida,
            qtd_guia_concluida: response.qdt_guia_concluida_mantida,
            qtd_guia_total: response.qdt_total_guia_mantida,
            qtd_item_com_analise: response.qdt_item_analisado_mantida,
            qtd_item_concluido: response.qdt_item_concluido_mantida,
            qtd_item_total: response.qdt_total_item_mantida,
            porc_analisados: (response.qdt_total_item_mantida> 0)?Number(((response.qdt_item_analisado_mantida+response.qdt_item_concluido_mantida)/response.qdt_total_item_mantida)*100).toFixed(2):0
          }
          this.analiseReapresentacao = {
            valor_acatado: response.reapresentadasValorAcatado,
            valor_glosado: response.reapresentadasValorGlosado, 
            valor_recursado: response.reapresentadasValorRecursado,
            valor_analisado: response.reapresentadasValorRecursado + response.reapresentadasValorAcatado,
            qtd_guia_com_analise: response.qdt_guia_analisada_reapresentada,
            qtd_guia_concluida: response.qdt_guia_concluida_reapresentada,
            qtd_guia_total: response.qdt_total_reapresentada,
            qtd_item_com_analise: response.qdt_item_analisado_reapresentada,
            qtd_item_concluido: response.qdt_item_concluido_reapresentada,
            qtd_item_total: response.qdt_total_item_reapresentada,
            porc_analisados: (response.qdt_total_item_reapresentada> 0)?Number(((response.qdt_item_analisado_reapresentada+response.qdt_item_concluido_reapresentada)/response.qdt_total_item_reapresentada)*100).toFixed(2):0
          }
          
        });
    },
  },
};
</script>
<style>
</style>